import { apiAddress } from '../ApiPlatform';

export const API_SELECT_CHECK_PRIVILEGE = apiAddress + '/privilege/select';
export const API_INSERT_PRIVILEGE = apiAddress + '/privilege/insert';
export const API_UPDATE_PRIVILEGE = apiAddress + '/privilege/update';
export const API_SELECT_AUTH_MENU_LIST =
  apiAddress + '/privilege/selectAuthMenu';
